import { Button } from '@wot/components';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SEARCH_SVG } from '../../assets/icons';
import { LANDING_IMG } from '../../assets/images';
import { capitalizeFirstLetter } from '../../utils/functions';

interface Props {
  title: string;
  searchBox: Boolean;
  subTitle?: string;
}

export default function LandingMain({ title, searchBox, subTitle }: Props) {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const navigate = useNavigate();

  return (
    <div className="flex flex-col lg:flex-row container m-auto py-16 items-center">
      <div className="flex flex-col justify-center items-center lg:items-start lg:w-3/5 w-full">
        <div className="lg:flex flex-col  w-full lg:w-4/5">
          <h1 className="text-white font-medium text-2xl md:text-5xl leading-tight md:leading-tight text-center lg:text-start">
            {title}
          </h1>
          <p className='text-white '>{subTitle}</p>
        </div>
        {searchBox ? (
          <div>
            
          <div className="max-w-lg mt-12 w-full flex lg:flex justify-center gap-5 lg:justify-start">
            <div className="h-12 flex items-center gap-2 bg-white w-full pl-4 rounded-full">
              <img src={SEARCH_SVG} alt="Search icon" className="w-4" />
              <form
                className="w-full flex items-center"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!searchTerm) {
                    return;
                  }
                  navigate(`/search/${capitalizeFirstLetter(searchTerm)}`);
                }}
              >
                <input
                  type="text"
                  placeholder="What do you want to learn?"
                  className="w-full  outline-none focus:outline-none placeholder:text-sm"
                  onChange={(e) => {
                    setSearchTerm((e.target as HTMLInputElement).value);
                  }}
                />
                <div className="">
                  <Button text="Find a tutor" size="lg" onClick={() => {}} />
                </div>
              </form>
            </div>
            <div>
                <Link to="/booktrail">
              <Button text="Book a Free Trial" size="lg" onClick={() => {}} />
                </Link>
            </div>          
          </div>
            <ul className='flex flex-col gap-3 text-white text-sm mt-8'>
              <li>✔ 10,000+ Students Taught</li>
              <li>✔ 2500+ Expert Tutors</li>
              <li>✔ Certified Tutors with 5+ Years Experience</li>
            </ul>
          </div>
        ) : null}
      </div>
      <div className="relative flex items-center justify-center">
        <img src={LANDING_IMG} alt="Student learning in a live 1:1 online class with tutor" className="lg:mt-0 mt-10 w-[200%] lg:w-full object-cover" />
      </div>
    </div>
  );
}
